import {
  IconAlertOctagon,
  IconAlertTriangle,
  IconCircleCheck,
  IconInfoCircle,
} from '../../icons/tabler';
import { Components, SvgIcon, Theme } from '../../material';
import { blend } from '../../system';
import { borderRadius } from '../tokens';

export const MuiAlert: Components<Theme>['MuiAlert'] = {
  defaultProps: {
    iconMapping: {
      success: (
        <SvgIcon fontSize="inherit">
          <IconCircleCheck />
        </SvgIcon>
      ),
      warning: (
        <SvgIcon fontSize="inherit">
          <IconAlertTriangle />
        </SvgIcon>
      ),
      error: (
        <SvgIcon fontSize="inherit">
          <IconAlertOctagon />
        </SvgIcon>
      ),
      info: (
        <SvgIcon fontSize="inherit">
          <IconInfoCircle />
        </SvgIcon>
      ),
    },
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      borderRadius: borderRadius.abs(theme.shape.borderRadius, 'm'),
      ...(ownerState.variant === 'filled'
        ? {
            backgroundColor:
              theme.palette[
                ownerState.color || ownerState.severity || 'success'
              ].main,
            color: theme.palette.getContrastText(
              theme.palette[
                ownerState.color || ownerState.severity || 'success'
              ].main
            ),
          }
        : // for now we don't really distinguish between these, UX team is on it
          ownerState.variant === 'standard' || ownerState.variant === 'outlined'
          ? {
              backgroundColor: blend(
                theme.palette.background.default,
                theme.palette[
                  ownerState.color || ownerState.severity || 'success'
                ].main,
                0.1
              ),
              borderColor:
                theme.palette[
                  ownerState.color || ownerState.severity || 'success'
                ].main,
              borderStyle: 'solid',
              borderWidth: 1,
              color: theme.palette.text.primary,
            }
          : {}),
    }),
  },
};
